document.addEventListener("click", function(e) {
  const target = e.target;
  if (!(target instanceof Element)) return;

  const popup = document.getElementById("productPopup");
  if (!popup) return;

  // OPEN POPUP
  if (target.closest(".product-card__btn")) {
    popup.classList.add("active");

    //  LOCK SCROLL
    document.body.classList.add("popup-open");

    return;
  }

  // CLOSE POPUP
  if (target.closest(".popup-overlay") || target.closest(".popup-close")) {
    
    popup.classList.remove("active");

    setTimeout(() => {
      document.body.classList.remove("popup-open");
    }, 400); 
  }

});

document.addEventListener("change", function(e) {
  const target = e.target;
  if (!(target instanceof Element)) return;

  // check if it's your variant radio
  if (target.matches('input[name="pack"]')) {

    // remove active from all
    document.querySelectorAll(".pack-option").forEach(label => {
      label.classList.remove("active");
    });

    // add active to selected parent
    const parentLabel = target.closest(".pack-option");
    if (parentLabel) {
      parentLabel.classList.add("active");
    }

  }

});

/**
 * @param {HTMLElement | null} button
 * @param {boolean} isLoading
 */
function setPopupAddButtonState(button, isLoading) {
  if (!button) return;

  if (isLoading) {
    button.classList.add("is-loading");
    button.style.pointerEvents = "none";
    button.style.opacity = "0.6";
    button.setAttribute("aria-busy", "true");
    if (button instanceof HTMLButtonElement) button.disabled = true;
    return;
  }

  button.classList.remove("is-loading");
  button.style.pointerEvents = "";
  button.style.opacity = "";
  button.removeAttribute("aria-busy");
  if (button instanceof HTMLButtonElement) button.disabled = false;
}

function getCartSectionIds() {
  return Array.from(document.querySelectorAll("cart-items-component"))
    .reduce((ids, component) => {
      if (component instanceof HTMLElement && component.dataset.sectionId) {
        ids.push(component.dataset.sectionId);
      }
      return ids;
    }, /** @type {string[]} */ ([]));
}

/**
 * @param {Record<string, any>} cartResponse
 * @param {string[]} sectionIds
 */
function broadcastCartUpdate(cartResponse, sectionIds) {
  document.dispatchEvent(
    new CustomEvent("cart:update", {
      bubbles: true,
      detail: {
        resource: cartResponse,
        sourceId: "product-card-popup-add",
        data: {
          source: "product-card-popup-add",
          itemCount: 1,
          sections: cartResponse?.sections || Object.fromEntries(sectionIds.map((id) => [id, ""])),
        },
      },
    })
  );
}

function openCartDrawer() {
  const drawer = /** @type {any} */ (document.querySelector("cart-drawer-component"));
  if (drawer && typeof drawer.open === "function") {
    drawer.open();
  }
}


document.addEventListener("click", function(e) {
  const target = e.target;
  if (!(target instanceof Element)) return;

  // BUY NOW CLICK
  if (target.closest("#popup-buy")) {
    const clickedButton = target.closest("#popup-buy");
    if (!(clickedButton instanceof HTMLElement)) return;

    const selectedInput = /** @type {HTMLInputElement | null} */ (
      document.querySelector('input[name="pack"]:checked')
    );

    if (!selectedInput) {
      alert("Please select a pack");
      return;
    }

    const selectedVariant = selectedInput.value;
    const sectionIds = getCartSectionIds();
    setPopupAddButtonState(clickedButton, true);

    fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    id: selectedVariant,
    quantity: 1,
    sections: sectionIds.join(','),
    sections_url: window.location.pathname
  })
})
.then(res => res.json())
.then(data => {
  broadcastCartUpdate(data, sectionIds);
  openCartDrawer();
})
.catch(err => {
  console.error("Error:", err);
})
.finally(() => {
  setPopupAddButtonState(clickedButton, false);
});

  }

});
